import { ADD_GUEST } from '../actionTypes'

export const addGuest = (data: object) => ({
  type: ADD_GUEST.name,
  api: {
    url: 'guests/add_guest',
    data,
  },
})
